import { render, staticRenderFns } from "./EditorTableMenu.vue?vue&type=template&id=3695cedf&scoped=true&"
import script from "./EditorTableMenu.vue?vue&type=script&lang=js&"
export * from "./EditorTableMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditorTableMenu.vue?vue&type=style&index=0&id=3695cedf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695cedf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VIcon,VList,VListItem,VMenu})
